export default {
  computed: {
    lng() {
      return this.$route.params.lng
    },
  },
  methods: {
    $lng(key, ns = '') {
      const nsKey = `${ns}:${key}`
      if (Object.prototype.hasOwnProperty.call(this.$store.state.i18n.lng, nsKey)) {
        return this.$store.state.i18n.lng[nsKey]
      } else if (Object.prototype.hasOwnProperty.call(this.$store.state.i18n.lng, key)) {
        return this.$store.state.i18n.lng[key];
      }

      return key
    },
  },
}
